import { createContext, useContext, ReactElement } from 'react';

export type FeatureGroup = {
  [featureName: string]: boolean | FeatureGroup;
};

export type FeatureFlags = string[] | FeatureGroup;

const FeaturesContext = createContext<FeatureGroup>({});

function transformFlags(features: FeatureFlags) {
  if (!Array.isArray(features)) {
    return features;
  }
  return Object.fromEntries(features.map(feature => [feature, true]));
}

export const useFeatures = (): FeatureGroup => {
  return useContext(FeaturesContext);
};

export const FeaturesProvider = ({ features = {}, children }: { features?: FeatureFlags; children: React.ReactNode }): ReactElement => {
  return <FeaturesContext.Provider value={transformFlags(features)}>{children}</FeaturesContext.Provider>;
};
